// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__hWFIj","paymentContainer":"PaymentPage_paymentContainer__1gG2T"};